import { IconWrapper } from '../runtime';
export default IconWrapper('folder_team_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M2.25 19.3125C1.00736 19.3125 0 18.3051 0 17.0625V3C0 1.75736 1.00736 0.75 2.25 0.75C3.75 0.75 5.25 0.75 6.75 0.75C7.23683 0.75 7.71053 0.9079 8.1 1.2L9.9 2.55C10.2895 2.8421 10.7632 3 11.25 3C14.75 3 18.25 3 21.75 3C22.9926 3 24 4.00736 24 5.25V17.0625C24 18.3051 22.9926 19.3125 21.75 19.3125H2.25Z",
      "fill": "#0065DC"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 8.25C0 6.59315 1.34315 5.25 3 5.25H21C22.6569 5.25 24 6.59315 24 8.25V19.5C24 21.1569 22.6569 22.5 21 22.5H3C1.34315 22.5 0 21.1569 0 19.5V8.25Z",
      "fill": "#1983FF"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M11.625 10.7812C11.625 11.8168 10.7855 12.6562 9.75 12.6562C8.71447 12.6562 7.875 11.8168 7.875 10.7812C7.875 9.74572 8.71447 8.90625 9.75 8.90625C10.7855 8.90625 11.625 9.74572 11.625 10.7812ZM6.65625 16.0312C6.65625 14.5815 7.8315 13.4062 9.28125 13.4062H10.4062C11.1345 13.4062 11.7936 13.7028 12.2691 14.1818C12.326 14.2392 12.3804 14.2991 12.4318 14.3615C12.8063 14.8153 13.0312 15.397 13.0312 16.0312V17.3438V18.0938H6.65625V17.25V16.0312ZM13.9688 13.4062C13.7016 13.4062 13.4453 13.4528 13.2076 13.5382C13.7977 14.2008 14.1562 15.0742 14.1562 16.0312V17.3438H17.3438C17.3438 17.3438 17.3438 17.008 17.3438 16.5938V15.6562C17.3438 14.4136 16.3364 13.4062 15.0938 13.4062H13.9688ZM14.4375 12.6562C15.2659 12.6562 15.9375 11.9847 15.9375 11.1562C15.9375 10.3278 15.2659 9.65625 14.4375 9.65625C13.6091 9.65625 12.9375 10.3278 12.9375 11.1562C12.9375 11.9847 13.6091 12.6562 14.4375 12.6562Z",
      "fill": "white"
    }
  })]);
});